import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddressPopup from '../../components/VoteRegistration/AddressPopup';

import { TransitionGroup } from 'react-transition-group';
import CssTransition from '../../components/Transition/CssTransition';

import WidgetHeader from '../Widget/WidgetHeader';
import AnswerButton from '../../components/Assessment/AnswerButton';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import ShareDrawer from '../../components/ShareDrawer';

import { isLongText } from '../../components/Shared/commonFunctions';

import { onShowAddressPopup } from './actions';

import { loadLocalRep } from '../LocalRep/actions';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import { Body, Container, RockTheVoteLabel } from '../DefaultStyles/Details';
import {
    Title,
    Content,
    Description,
    DetailsContainer,
    Details,
    Footer
} from '../DefaultStyles/Shared';

import { setOverlayPartnerVisible } from '../Widget/actions';

import rockTheVoteLogo from '../../assets/images/rock-the-vote-logo.png';
import { RockTheVoteDetails } from '../../components/Shared/rockTheVoteDetails';

class VoteRegistrationDetails extends React.Component {
    constructor(props) {
        super(props);
        if (!this.props.localRepFound) this.props.loadLocalRep();
    }

    componentDidMount() {
        this.forceUpdate();
    }

    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner
                    transitionType="right-to-left"
                    logo={rockTheVoteLogo}
                    name={this.props.rockTheVoteTitle}
                    description={this.props.rockTheVoteDescription}
                />
                <Body>
                    <WidgetHeader />
                    <Content isContactAction={false} isSingleAction={true}>
                        <Title
                            isLongText={isLongText(this.props.title, 60)}
                            isExtraLongText={isLongText(this.props.title, 95)}
                            onClick={e => this.props.setOverlayPartnerVisible(true, e, false)}
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                            }}
                        />
                        <DetailsContainer>
                            <Details>
                                <Description
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, false)
                                    }
                                    isLongText={isLongText(this.props.subTitle, 90)}
                                    isExtraLongText={isLongText(this.props.subTitle, 160)}
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.subTitle
                                    }}
                                />
                                <RockTheVoteLabel
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, true)
                                    }
                                >
                                    {this.props.rockTheVoteLabel}
                                </RockTheVoteLabel>
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <AutoScalingButtonSet mobileStyled={true} mobileLeftPosition={8}>
                        <AnswerButton
                            text={this.props.registerButtonText}
                            useLoadingSpinner={false}
                            onClick={() => {
                                this.props.onShowAddressPopup(
                                    true,
                                    this.props.actionIdentifier,
                                    this.props.actionInitiated
                                );
                            }}
                        />
                    </AutoScalingButtonSet>
                    <Footer>
                        <ShareDrawer rightAlign backgroundColor={'#fff'} />
                    </Footer>
                    <TransitionGroup>
                        {this.props.showAddressPopup && (
                            <CssTransition key="alert" in={this.props.showAddressPopup}>
                                <AddressPopup
                                    onBack={() => {
                                        this.props.onShowAddressPopup(
                                            false,
                                            this.props.actionIdentifier
                                        );
                                    }}
                                />
                            </CssTransition>
                        )}
                    </TransitionGroup>
                </Body>
            </Container>
        );
    }
}

VoteRegistrationDetails.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    showAddressPopup: PropTypes.bool,
    onShowAddressPopup: PropTypes.func,
    actionIdentifier: PropTypes.string.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    loadLocalRep: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    rockTheVoteTitle: PropTypes.string,
    rockTheVoteDescription: PropTypes.string,
    registerButtonText: PropTypes.string.isRequired,
    rockTheVoteLabel: PropTypes.string.isRequired
};

export default connect(
    state => {
        const defaultTitle = 'Register to vote.';
        const defaultSubtitle =
            "Remember, you can't vote in the upcoming election unless you're registered. " +
            'Take a few minutes and register to vote today.';

        return {
            title: state.widget.activeAction.title || defaultTitle,
            subTitle: state.widget.activeAction.text || defaultSubtitle,
            showAddressPopup: state.voteRegistration.showAddressPopup,
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.voteRegistration.actionInitiated,
            localRepFound: state.localRep.localRepData.representative !== undefined,
            rockTheVoteTitle: RockTheVoteDetails.title,
            rockTheVoteDescription: RockTheVoteDetails.description,
            rockTheVoteLabel: RockTheVoteDetails.label,
            registerButtonText: state.widget.activeAction.customButtonText || 'REGISTER'
        };
    },
    {
        onShowAddressPopup,
        loadLocalRep,
        setOverlayPartnerVisible
    }
)(VoteRegistrationDetails);



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistrationDetails.jsx